export const componentEndpointUrl = (componentId?: string) => {
	const componentUrl = componentId ? `/${componentId}` : '';
	return `/rest/api/2/component${componentUrl}`;
};
